import * as React from "react";
import { useState, useEffect } from "react";
import style from "./patientDetailTable.module.css";
import Pstyle from "./prescription.module.css";
import classNames from "classnames";
import CustomModal from "shared/components/Modal";
import { IoClose } from "react-icons/io5";
import { doctorGetPrescription } from "shared/services/DoctorService";
import DoctorReferModel from "shared/components/DoctorEmpty/DoctorReferModel";
import logo from "assets/images/smallLogo.png";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import { notifyError } from "shared/components/A_New_Components/ToastNotification";
import { useTranslation } from "react-i18next";
interface Props {
  patientDetail: any;
  medicine?: any;
  doctor?: any;
}
function PatientDetailTable(props: Partial<Props>) {
  const { t }: any = useTranslation();
  const { patientDetail, medicine, doctor } = props;
  const [showAddProperty, setShowAddProperty] = useState(false);
  const [appointmentId, setAppointmentId] = useState();
  console.log(patientDetail, ".....patientDetail");
  return (
    <div className={style.payment}>
      <div
        className={classNames(
          doctor == "physiotherists"
            ? style.Physiotherists
            : doctor == "Nutrists"
            ? style.Nutrists
            : doctor == "ParaMedic"
            ? style.ParaMedic
            : doctor == "Psychologists"
            ? style.Psychologists
            : style.headerOuter
        )}
      >
        <p className={style.headerclass}>{t("date")}</p>
        <p className={style.headerclass}>{t("time")}</p>
        <p className={style.headerclass}>Dr {"_name"}</p>
        <p className={style.headerclass}>{t("status")}</p>
        <p className={style.headerclass}>{t("serviceName")}</p>
        <p className={style.headerclass}>{t("prescription")}</p>
      </div>
      <div className={style.tableData}>
        <table
          style={{
            margin: "0px",
          }}
        >
          <tbody className={style.wapper}>
            {patientDetail?.map((val: any, key: any) => {
              console.log(val, ".....valued per person ");

              return (
                <tr className={style.tableRow} key={key}>
                  <td className={style.w20}>
                    {val?.appointmentDateAndTime
                      ? new Date(
                          val.appointmentDateAndTime
                        ).toLocaleDateString()
                      : ""}
                  </td>
                  <td className={style.w20}>
                    {val?.appointmentDateAndTime
                      ? new Date(val.appointmentDateAndTime).toLocaleTimeString(
                          "en-US",
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                          }
                        )
                      : ""}
                  </td>

                  <td className={style.w20}>{val?.doctorId?.name}</td>
                  <td className={style.w20}>{val?.status}</td>
                  <td className={style.w20}>{val?.appointmentType}</td>
                  <td
                    className={classNames(style.w20, style.Cursor, style.blue)}
                    onClick={() => {
                      setShowAddProperty(true);
                      setAppointmentId(val?.ePrescription?._id);
                    }}
                  >
                    {t("viewDetails")}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <CustomModal
          showModal={showAddProperty}
          children={
            <ViewDetail
              t={t}
              patientDetail={patientDetail}
              setShowAddProperty={setShowAddProperty}
              appointmentId={appointmentId}
            />
          }
        />
      </div>
    </div>
  );
}

export default PatientDetailTable;

interface Props {
  t?: any;
  setShowAddProperty: any;
  appointmentId: any;
}

export const ViewDetail = (props: Partial<Props>) => {
  interface Medicine {
    medicineName: string;
    medicineBrand: string;
    medicineStrength: string;
    dosage: string;
  }

  interface Tests {
    testName: string;
  }

  const [loading, setLoading] = useState(false);
  const { t, setShowAddProperty, appointmentId, patientDetail } = props;
  const [patientdata, setPatientData] = useState<any>([]);
  const [doctordata, setDoctorData] = useState<any>([]);
  const [medicine, setMedicine] = useState<Medicine[]>([]);
  const [data, setData] = useState<any>([]);
  const [Symptopms, setSymptopms] = useState<any>([]);
  const [test, setTest] = useState<Tests[]>([]);

  const handleclose = () => {
    setShowAddProperty(false);
  };

  useEffect(() => {
    if (!appointmentId) {
     notifyError("appointmentId is not provided.");
      return;
    }
    setLoading(true);
    doctorGetPrescription(appointmentId)
      .then((res: any) => {
        console.log(res?.data);
        setMedicine(res?.data?.medicines);
        setPatientData(res?.data?.patientId);
        setDoctorData(res?.data?.doctorId);
        setData(res?.data);
        setSymptopms(res?.data?.appointmentId?.history?.symptoms);
        setTest(res.data.test);
      })
      .catch((err: any) => {})
      .finally(() => {
        setLoading(false);
      });
  }, [appointmentId]);
  function calculateAge(dateOfBirthString: string) {
    if (!dateOfBirthString) return "Date of birth not provided";
    const [day, month, year] = dateOfBirthString.split("/")?.map(Number);
    const dateOfBirth = new Date(year, month - 1, day);
    const ageDate = new Date(Date.now() - dateOfBirth.getTime());
    const age = Math.abs(ageDate.getUTCFullYear() - 1970);
    return age;
  }
  const createPDF = () => {
    const doc = new jsPDF();
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.setTextColor("#000000");
    doc.text(t("prescription"), 10, 10);

    doc.setFontSize(16);
    doc.setTextColor("#000000");
    doc.setFont("helvetica", "bold");
    doc.text(`${data?.doctorId?.name}`, 10, 20);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(`${t("address")}:`, 10, 26);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);

    const pageWidth = doc.internal.pageSize.getWidth();
    const maxTextWidth = pageWidth * 0.65;

    const addressText = `${data?.doctorId?.location?.address || ""}`;
    const wrappedText = doc.splitTextToSize(addressText, maxTextWidth);

    // Determine height offset based on number of lines
    const lineHeight = 6; // You can tweak this
    const startX = 28;
    const startY = 26;

    doc.setFont("helvetica", "bold");
    doc.text(`${t("address")}:`, 10, startY); // Static label

    doc.setFont("helvetica", "normal");
    doc.text(wrappedText, startX, startY);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(`${t("phone")}:`, 10, 34);
    doc.setFont("helvetica", "normal");
    doc.text(`${data?.doctorId?.phoneNumber || ""}`, 28, 34);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text(`${t("email")}:`, 10, 38);
    doc.setFont("helvetica", "normal");
    doc.text(`${data?.doctorId?.email}`, 28, 38);
    const base64Image =
      "data:image/png;base64,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";

    try {
      const imgWidth = 30;
      const imgHeight = 30;

      doc.addImage(base64Image, "PNG", 160, 3, imgWidth, imgHeight);
    } catch (error) {
      notifyError(`${t("errorAddingImage")}:`);
    }

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.setTextColor("#000000");

    // Top Divider Line
    doc.setDrawColor("#7d7d7d");
    doc.line(10, 42, 200, 42);

    // Patient Information Section
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(t("patientInformation"), 10, 48);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor("#000000");
    const appointmentDate = dayjs(
      data?.patientAppointments?.appointmentDateAndTime
    ).format("DD-MM-YYYY");

    // Left Column
    doc.text(`${t("patientName")}: ` + `${data?.patientId.name}`, 10, 54);
    doc.text(`${t("date")}: ` + appointmentDate, 10, 62);
    doc.text(`${t("cell")}: ` + `${data?.patientId?.phone}`, 10, 70);
    doc.text(
      `${t("disease")}: ` +
        `${
          data?.appointmentId?.history?.diseases?.join(" ") || "Not Provided"
        }`,
      10,
      78
    );
    doc.text(
      `${t("heartRate")}: ` +
        `${data?.appointmentId?.history?.heartRate || "Not Provided"}`,
      10,
      86
    );
    doc.text(
      `${t("address")}: ` +
        `${data?.patientId?.address?.address}, ${data?.patientId?.address?.city}`,
      10,
      94
    );
    // Right Column
    doc.text("MR NO: " + `${data?.patientId?.mrNo || "--"}`, 120, 54);
    doc.text(
      `${t("age")}: ` + `${calculateAge(patientdata?.dateOfBirth) || "--"}`,
      120,
      62
    );
    doc.text(
      `${t("sugarLevel")}: ` +
        `${data?.appointmentId?.history?.sugar || "Not Provided"}`,
      120,
      70
    );
    doc.text(
      `${t("temperature")}: ` +
        `${data?.appointmentId?.history?.temperature || "Not Provided"}`,
      120,
      78
    );
    doc.text(
      `${t("weight")} (Kg): ` +
        `${data?.appointmentId?.history?.weight || "--"} Kg`,
      120,
      86
    );
    doc.text(
      `${t("bp")}: ` +
        `${
          data?.appointmentId?.history?.bloodPressure?.systolicPressure || "--"
        }/` +
        `${
          data?.appointmentId?.history?.bloodPressure?.diastolicPressure || "--"
        }`,
      120,
      94
    );
    // Bottom Divider Line
    doc.setDrawColor("#7d7d7d");
    doc.line(10, 100, 200, 100);

    // Symptoms and Findings Section

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(t("symptomsAndFindings"), 10, 110);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    doc.text(
      `${t("symptoms")}: ` +
        `${data?.appointmentId?.history?.symptoms || "-------"}`,
      10,
      120
    );

    // Clinic Findings
    const findingsText = data?.appointmentId?.history?.description || "------";
    const findingsLines = doc.splitTextToSize(findingsText, 180);
    doc.text(`${t("clinicFindings")}: ` + `${findingsText}`, 10, 130);
    const lastY = 138 + findingsLines.length;

    // Divider Line
    doc.setDrawColor("#7d7d7d");
    doc.line(10, lastY + 4, 200, lastY + 4);

    const newLastTestY = lastY + 10;

    // Laboratory Tests Section
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(t("laboratoryTest"), 10, newLastTestY);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    const tests = test || [];
    tests.forEach((test: any, index: number) => {
      const yPosition = newLastTestY + 10 + index * 8;
      doc.text(`- ${test?.testName}`, 10, yPosition);
    });

    const lastTestY = newLastTestY + 10 + tests.length * 8;
    doc.setDrawColor("#7d7d7d");
    doc.line(10, lastTestY + 4, 200, lastTestY + 4);
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(t("medicineInformation"), 10, lastTestY + 14);

    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");

    // Table Headers
    doc.setTextColor("#000000");
    doc.text(t("medicineName"), 10, lastTestY + 24);
    doc.text(t("dosage"), 80, lastTestY + 24);
    doc.text(t("duration"), 140, lastTestY + 24);

    doc.setDrawColor("#7d7d7d");
    doc.line(10, lastTestY + 28, 200, lastTestY + 28);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    const maxWidth = 60;
    medicine?.forEach((medicine: any, index: number) => {
      const yPosition = lastTestY + 38 + index * 20;

      const splitName = doc.splitTextToSize(
        medicine.medicineName || "----",
        maxWidth
      );
      doc.text(splitName, 10, yPosition);
      doc.text(medicine.dosage || "----", 80, yPosition);
      doc.text(`${medicine.days || "----"} days`, 140, yPosition);
    });

    // Footer Divider
    doc.setDrawColor("#7d7d7d");
    doc.line(10, lastTestY + 100, 200, lastTestY + 100);

    // Footer Section
    doc.setFontSize(10);
    doc.setFont("helvetica", "italic");
    doc.setTextColor("#555555");
    doc.text(t("generatedDigitally"), 105, lastTestY + 110, {
      align: "center",
    });
    // Save the PDF
    doc.save("prescription.pdf");
  };

  return (
    <div>
      {loading ? (
        <DoctorReferModel showModal={loading} />
      ) : (
        <>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <IoClose onClick={handleclose} className={style.close} />
          </div>
          <div className={Pstyle.container}>
            <div
              className={classNames(
                Pstyle.row,
                Pstyle.borderBottom,
                Pstyle.padding16
              )}
            >
              <div style={{ width: "70%" }}>
                <p
                  className={classNames(
                    Pstyle.bold,
                    Pstyle.noMargin,
                    Pstyle.largeText
                  )}
                >
                  {doctordata?.name}
                </p>
                <p className={classNames(Pstyle.noMargin)}>
                  {doctordata?.qualifications}
                </p>
                <p className={classNames(Pstyle.noMargin)}>
                  PM&DC Reg: {doctordata?.pmdcNumber}
                </p>
              </div>
              <img src={logo} className={Pstyle.logo} alt="Logo" />
            </div>

            <div style={{ padding: "16px 0" }}>
              {" "}
              <div className={Pstyle.row}>
                <p className={classNames(Pstyle.heading)}>
                  {t("patientName")}:{" "}
                  <span className={classNames(Pstyle.value)}>
                    {patientdata?.name}
                  </span>
                </p>
                <p className={classNames(Pstyle.heading)}>
                  M.R No:{" "}
                  <span className={classNames(Pstyle.value)}>
                    {patientdata?.mrNo}
                  </span>
                </p>
              </div>
              <div className={classNames(Pstyle.row, Pstyle.alignItemsCenter)}>
                <p className={classNames(Pstyle.heading)}>
                  {t("date")}:{" "}
                  <span className={classNames(Pstyle.value)}>
                    {dayjs(
                      data?.patientAppointments?.appointmentDateAndTime
                    ).format("DD-MM-YYYY")}
                  </span>
                </p>
                <p className={classNames(Pstyle.heading)}>
                  {t("age")}:{" "}
                  <span className={classNames(Pstyle.value)}>
                    {calculateAge(patientdata?.dateOfBirth)} years old
                  </span>
                </p>
              </div>
              <div className={classNames(Pstyle.row, Pstyle.alignItemsCenter)}>
                <p className={classNames(Pstyle.heading)}>
                  {t("weight")} (Kg):{" "}
                  <span className={classNames(Pstyle.value)}>
                    {data?.appointmentId?.history?.weight}
                  </span>
                </p>

                <p className={classNames(Pstyle.heading)}>
                  {t("BP")}:{" "}
                  <span className={classNames(Pstyle.value)}>
                    {`${data?.appointmentId?.history?.bloodPressure?.systolicPressure}/ ${data?.appointmentId?.history?.bloodPressure?.diastolicPressure}`}
                  </span>
                </p>
              </div>
              <div className={classNames(Pstyle.row, Pstyle.alignItemsCenter)}>
                <p className={classNames(Pstyle.heading)}>
                  {t("temperature")}:{" "}
                  <span className={classNames(Pstyle.value)}>
                    {`${data?.appointmentId?.history?.temperature}`}
                  </span>
                </p>
                <p className={classNames(Pstyle.heading)}>
                  {t("sugar")}:{" "}
                  <span className={classNames(Pstyle.value)}>
                    {`${data?.appointmentId?.history?.sugar}`}
                  </span>
                </p>
              </div>
              <p className={classNames(Pstyle.heading)}>
                {t("heartRate")}:{" "}
                <span className={classNames(Pstyle.value)}>
                  {`${data?.appointmentId?.history?.heartRate}`}
                </span>
              </p>
              <p className={classNames(Pstyle.heading)}>
                {t("diseases")}:{" "}
                {data?.appointmentId?.history?.diseases?.map((i: any) => (
                  <span className={classNames(Pstyle.value)}>{i}</span>
                ))}
              </p>
            </div>

            <div
              className={classNames(
                Pstyle.row,
                Pstyle.borderTop,
                Pstyle.borderBottom
              )}
            >
              <p className={classNames(Pstyle.mainHeading)}>{t("symptoms")}</p>
              <p className={classNames(Pstyle.mainHeading)}>
                {t("clinicalFindings")}
              </p>
            </div>

            <div
              className={Pstyle.row}
              style={{ padding: "16px 0", margin: "0px" }}
            >
              <p className={classNames(Pstyle.mainValue, Pstyle.textLeft)}>
                {data?.appointmentId?.history?.description}
              </p>
            </div>
            <div
              className={classNames(
                Pstyle.row,
                Pstyle.borderTop,
                Pstyle.borderBottom,
                Pstyle.marginTop16
              )}
            >
              <p className={classNames(Pstyle.mainHeading)}>
                {t("laboratoryTest")}
              </p>
            </div>

            {test?.map((test, index) => (
              <div style={{ padding: "16px 0" }} key={index}>
                <p className={classNames(Pstyle.mainValue)}>{test.testName}</p>
                {/* <Downloader link={test?.res} /> */}
              </div>
            ))}

            <div>
              {/* Header Row */}
              <div
                className={classNames(
                  Pstyle.row,
                  Pstyle.borderBottom,
                  Pstyle.borderTop,
                  Pstyle.borderBottom,
                  Pstyle.alignItemsCenter
                )}
              >
                <p className={classNames(Pstyle.mainHeading)}>
                  {t("medicineName")}
                </p>
                <p className={classNames(Pstyle.mainHeading)}>{t("dosage")}</p>
                <p className={classNames(Pstyle.mainHeading)}>
                  {t("duration")}
                </p>
              </div>

              {medicine?.map((med: any, index) => (
                <div
                  key={index}
                  className={classNames(
                    Pstyle.row,
                    Pstyle.borderBottom,
                    Pstyle.alignItemsCenter
                  )}
                  style={{ padding: "16px 0" }}
                >
                  <p
                    style={{ width: "33%" }}
                    className={classNames(Pstyle.mainValue)}
                  >
                    {med.medicineName}, {med.medicineBrand},{" "}
                    {med.medicineStrength}
                  </p>
                  <p className={classNames(Pstyle.mainValue)}>{med.dosage}</p>
                  <p className={classNames(Pstyle.mainValue)}>
                    {med.days} {t("days")}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
      <div
        style={{
          // border: "2px solid black",
          marginBottom: "-10px",
          display: "flex",
          flexDirection: "row-reverse",
          position: "sticky",
        }}
      >
        <button className={classNames(Pstyle.button)} onClick={createPDF}>
          {t("downloadPrescription_")}
        </button>
      </div>
    </div>
  );
};
